import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '@stores/auth.store';
import { cn } from '@lib/utils';

interface GuestSignInLinkProps {
  children?: ReactNode;
  className?: string;
}

export function GuestSignInLink({
  children = '登录后使用',
  className,
}: GuestSignInLinkProps) {
  const clearAuth = useAuthStore((state) => state.clearAuth);

  return (
    <Link
      to="/login"
      onClick={clearAuth}
      className={cn('guest-sign-in-link', className)}
    >
      {children}
    </Link>
  );
}
